module.exports = {
  login:'Iniciar sesión',
  taption: 'Taption',
  ways_to_use_taption:'Maneras de usar Taption',
  faq:'Preguntas frecuentes',
  pricing:'Precios',
  language:'Idioma',
  product:'Productos'
}
